var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.952 19.37a9.641 9.641 0 01-7.41-2.91A9.963 9.963 0 0111.67 9.42c0-1.515.334-2.98.957-4.304.17-.361.509-.908.744-1.28.104-.158-.027-.366-.213-.333-.328.049-.831.158-1.515.371-4.255 1.351-7.268 5.354-7.268 10.074 0 5.83 4.654 10.554 10.396 10.554 3.172 0 6.016-1.443 7.924-3.724.328-.393.63-.754.897-1.192a.22.22 0 00-.224-.334c-.465.093-.935.099-1.416.12z"
  })));
}
export default SvgDarkTheme;